import React from 'react';
import PropTypes from 'prop-types';
import DocumentPreview from '../../modules/documentPreview';
import DocumentService from '../../../services/document.service';

const DocPreviewModal = ({
  t,
  item,
  active,
  toggleModal,
}) => (
  <React.Fragment>
    <div className={`modal boxs ${active ? 'active' : ''}`}>
      <div className="modal-dialog doc-preview">
        <div className="boxs docpreview boxs chosefl">
          <div className="sliderarrows boxs">
            <div className="arrowtop">
              <a
                href="#"
                className="closemodalbtn"
                onClick={e => toggleModal(e, false)}
              ><img src="/img/closemodal.svg" alt="close" />
              </a>
            </div>
          </div>
          {item && <React.Fragment>
            <DocumentPreview item={item} showComments={false} />
          </React.Fragment>}
        </div>
      </div>
    </div>
  </React.Fragment>
);

DocPreviewModal.propTypes = {
  t: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  toggleModalCom: PropTypes.func.isRequired,
};

export default DocPreviewModal;



// WEBPACK FOOTER //
// ./src/components/modalWindows/documentPreviewModal/DocPreviewModal.jsx